'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.module = undefined;

var _Dispatcher = require('flux/lib/Dispatcher');

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('ifeis.dispatcher', []).service('dispatcher', _Dispatcher2.default);

exports.module = _module;
exports.default = _Dispatcher2.default;


//////////////////
// WEBPACK FOOTER
// ./dispatcher/index.js
// module id = 101
// module chunks = 0